import { apiProvider } from './api';
import Select from './components/Select.vue';
import { NAME } from './constants';
import { router } from './router';

export const Pracovnik = {
	name: NAME,
	apiProvider,
	router,
	components: {
		Select,
	},
};
